import React, {Component} from 'react';
import SecondServer from '../database/SecondServer'
import {siteAccessCode, dailyEmails, dailyRptTime, dailyReportName } from '../database/apiv2SiteAccessor';
import { inverseTimeOfDay, sanitizeDateTime, timeOfDay } from '../timeFunctions/timeFns';
import {urlGetScripts, urlGetSite, urldrSupport} from '../database/apiUrls'
import DropDown2 from '../Report/Controls/DropDown2'
import {canWrite, cachedPerms} from "./SitePerms"
import {RelativePopup} from '../Alert/Popup'
import HistoryPopup from './HistoricalPopup'

import './reportspane.css';
import './SitePane.css';

const readOnly={'readOnly':"1"};

export default class ReportsPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readwrite: {...readOnly},
      reportTime: '',
      emailRecips: [],
      reportAvail: [],
      currentReport: undefined,
      rptType: "Daily",
      rptDay: "Last Day",
      originalSite: undefined,
      originalScripts: undefined,
      loading: true,
      utcOffset: 0,
      popupMsg: undefined,
      histShow: false,
    }
    this.ss = undefined
    this._mounted = undefined
    this.editClick = this.editClick.bind(this)
    this.handleEdit = this.handleEdit.bind (this)
    this.sendNow = this.sendNow.bind(this)
    this.sentAt = undefined
    this.typeDropdown = ['Daily', 'Monthly',]
    this.timeDropdown = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00",
                        "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
                        "13:00", "14:00", "15:00", "16:00", "17:00", "18:00",
                        "19:00", "20:00", "21:00", "22:00", "23:00", ]
    this.dayDropdown = ["Last Day", "1", "2", "3","4", "5", "6", "7",
                        "8", "9", "10", "11","12", "13", "14", "15",
                        "16", "17", "18", "19","20", "21", "22", "23",
                        "24", "25", "26", "27","28", "29", "30",]
  }

  async componentDidMount() {
    this._mounted = true
    this.ss = new SecondServer(this.props);
    const ac = siteAccessCode(this.props.getActiveSite())
    const jsr = await this.ss.apiData(urlGetScripts (ac))
    const name = jsr?.data ?? []
    const resp = await this.ss.apiData (urlGetSite(ac));
    const site = resp?.data?.data
    if (!site) {
      this.setMountedState ({originalSite: undefined, loading: false})
      return
    }
    this.reportStateFromAPI (site, name)
  }
  componentWillUnmount() {
    this._mounted = false
    this.ss.cancel("")
  }
  setMountedState (obj) {
    if (this._mounted) {
      this.setState(obj)
    }
  }
  reportStateFromAPI(site, name) {
    const emails = dailyEmails(site).join()
    const utcTime = sanitizeDateTime(dailyRptTime(site))
    const offset = new Date().getTimezoneOffset()
    const tod = timeOfDay(utcTime, offset)
    const rptType = site?.daily_report_type ?? "Daily"
    this.setMountedState ({reportAvail: name, emailRecips: emails, reportTime: tod, rptType: rptType,
         currentReport: dailyReportName(site), rptDay: site?.daily_report_day ?? "Last Day",
        originalSite: site, originalScripts: name, utcOffset: offset, loading:false})
  }
  editMode () {
    return Object.hasOwn(this.state.readwrite, 'readOnly')
  }
  editLabel () {
    return this.editMode() ? "Edit" : "Save"
  }
  dependentLabel () {
    return this.editMode() ? "Send Now": "Cancel"
  }
  editClick () {
    if (!this.editMode ()) 
      this.saveState()
    this.toggleMode()
  }
  toggleMode () {
    if (canWrite(cachedPerms(this.props.getActiveSite()))) {
      const newState = this.editMode() ? {} : readOnly
      this.setMountedState({readwrite: newState})
    }
  }
  async sendNow () {
    if (this.editMode()) {
      const postBody = {
        ac: siteAccessCode(this.props.getActiveSite()),
        invoTyp: "2",
      }
      const sent = Date.now()
      this.setMountedState({popupMsg: "Report sent. It should reach your inbox within a few minutes"})
      if (this.sentAt === undefined || Math.abs(sent - this.sentAt) > 3000) {
        this.sentAt = sent
        await this.ss.apiInsertData(urldrSupport(), postBody)
      }
    }
    else {
      this.reportStateFromAPI(this.state.originalSite, this.state.originalScripts)
      this.toggleMode()
    }
  }
  handleEdit(evt) {
    let item = {}
    item[evt.target.id] = evt.target.value
    this.setMountedState({...item})
  }
  async saveState () {
    const saveObj = {
      daily_email_adrs: this.state.emailRecips.split(','),
      daily_report_tod: inverseTimeOfDay(this.state.reportTime, this.state.utcOffset),
      daily_report_type: this.state.rptType,
      daily_report_day: this.state.rptDay,
    }
    if (this.state.currentReport !== undefined)
      saveObj['script_name'] = this.state.currentReport
    // console.log (saveObj)
    const ac = siteAccessCode(this.props.getActiveSite())
    this.ss.apiSaveData(urlGetSite(ac), saveObj)
  }
  textInput (label, prop, className='') {
    const data = this.state[prop]
    const rw = this.state.readwrite
    const borderStyle = this.editMode() ? " display-style" : " input-border"
    return (
      <label className={"form-label site-label "+className}>{label}
        <input type="text" id={prop} className={"form-control"+borderStyle} value={data} 
          onChange={this.handleEdit} {...rw}/>
      </label>
    )
  }
  onTimeUpdate(param) {
    this.setMountedState({reportTime: this.timeDropdown[param]})
  }
  onTypeUpdate (param) {
    this.setMountedState ({rptType: this.typeDropdown[param]})
  }
  onDayUpdate (param) {
    this.setMountedState ({rptDay: this.dayDropdown[param]})
  }
  onUpdate (param) {
    this.setMountedState ({currentReport: this.state.reportAvail[param]})      
  }
  render() {
    const el = this.editLabel()
    const borderStyle = this.editMode() ? " display-style" : " input-border"
    const msg = this.state.loading === true ? "Getting reports..." : "Unable to get reports. Try clicking refresh"
    if (!this.state.originalSite) {
      return (
        <div className="reports-pane">
          <div className="row rpt-first">
            <label className={"col form-label site-label"}>{msg}
            </label>
          </div>
        </div>
      )
    }
    return (
      <div className="reports-pane">
        <div className="rpt-edit rpt-placement" onClick={this.editClick}>{el}</div>
        <div className="rpt-edit rpt-place2" onClick={this.sendNow}>{this.dependentLabel()}</div>
        <HistoryPopup show={this.state.histShow} {...this.props} />
        <form key="report">
         <div className="row rpt-first">
         <RelativePopup popupMsg={this.state.popupMsg} onClose={()=>this.setMountedState({popupMsg:undefined})}/>
         <label className={"col form-label site-label"}>Available Reports
          <DropDown2 options={this.state.reportAvail} onUpdate={(param)=>this.onUpdate(param)}
            {...this.state.readwrite} value={this.state.currentReport} 
            anchorStyle={'btn-light w-100'+borderStyle} /></label>
          </div>
          <div className="row">
          <label className='col form-label site-label'>Report Interval
          <DropDown2 options={this.typeDropdown} anchorStyle={'btn-light form-control '+borderStyle} 
            {...this.state.readwrite} value={this.state.rptType} 
            onUpdate={(param)=>this.onTypeUpdate(param)}/></label>
          <label className='col form-label site-label'>Report Time
          <DropDown2 options={this.timeDropdown} anchorStyle={'btn-light form-control '+borderStyle}
            {...this.state.readwrite} value={this.state.reportTime} 
             onUpdate={(param)=>this.onTimeUpdate(param)}/></label>
          <label className='col form-label site-label'>Day (Monthly Only)
            <DropDown2 options={this.dayDropdown} anchorStyle={'btn-light form-control '+borderStyle}
             {...this.state.readwrite} onUpdate={(param)=>this.onDayUpdate(param)}
             value={this.state.rptDay} /> </label>
         </div>
        {this.textInput("Email Recipients (comma separated)", 'emailRecips', 'w-100')}
        </form>
      </div>
    )
  }
}
